import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { PageToolbar, usePageTranslation } from "@/components/PageToolbar";

export default function Countries() {
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    api.get("/countries").then((r) => setCountries(r.data));
  }, []);

  const blocks = useMemo(() => {
    const b = { title: "Countries & Film Industries", sub: "Every nation has a cinema story. Explore national industries, from Hollywood and Bollywood to Nollywood and beyond." };
    countries.forEach((c) => (b[`ov-${c.code}`] = c.overview));
    return countries.length ? b : null;
  }, [countries]);
  const { lang, tr, busy } = usePageTranslation(blocks, "countries-list");

  return (
    <main data-testid="countries-page" className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
      <p className="eyebrow">Geographic Cinema Atlas</p>
      <h1 className="font-display font-bold text-4xl sm:text-5xl mt-2 text-[#1c1512]">{tr("title", "Countries & Film Industries")}</h1>
      <p className="text-[#6b5d51] mt-3 max-w-2xl">{tr("sub", "Every nation has a cinema story. Explore national industries, from Hollywood and Bollywood to Nollywood and beyond.")}</p>
      <div className="mt-4 flex flex-wrap items-center gap-4">
        <PageToolbar speakText={countries.map((c) => `${c.name}: ${tr(`ov-${c.code}`, c.overview)}`).join(" ")} busy={busy} lang={lang} />
        <Link to="/cities" data-testid="browse-cities-link" className="inline-flex items-center gap-1 font-display font-semibold text-[#7d1a1a] link-underline">
          Or browse by film city →
        </Link>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-10">
        {countries.map((c) => (
          <Link
            key={c.code}
            to={`/country/${c.code}`}
            data-testid={`country-card-${c.code}`}
            className="poster-card bg-[#fbf8f1] border border-[#d8ccb8] p-6 group"
          >
            <div className="flex items-start justify-between">
              <span className="text-4xl">{c.flag}</span>
              <span className="font-mono-label text-[10px] tracking-[0.2em] uppercase text-[#8a7c6d]">{c.film_count} films indexed</span>
            </div>
            <h2 className="font-display font-bold text-2xl mt-3 group-hover:text-[#7d1a1a] transition-colors">{c.name}</h2>
            <p className="text-sm font-medium text-[#b06810] mt-1">{c.industry}</p>
            <p className="text-sm text-[#6b5d51] mt-3 line-clamp-3">{tr(`ov-${c.code}`, c.overview)}</p>
            <p className="flex items-center gap-1 text-sm font-medium text-[#7d1a1a] mt-4">
              Visit cinema home <ArrowRight className="w-4 h-4" />
            </p>
          </Link>
        ))}
      </div>
    </main>
  );
}
